<template>
  <div class="column-card" @click="goDetail">
    <div class="column-top">
      <img class="column-logo" :src="rowData.iconUrl"/>
      <div class="column-info-warp">
        <div class="title-warp">
          <span :inOrOut="rowData.inOrOut" class="sd_column_card_name_tag">{{rowData.inOrOut === 1 ? '内部' : '外部'}}</span>
          <span class="column-title">
            {{rowData.name}}{{rowData.name}}
          </span>
        </div>
        <div class="info">
            <span>{{rowData.postNum}}篇文章</span>
            <span>{{getDateDiff(rowData.updateTime)}}更新</span>
        </div>
        <div class="view-info">
          <div class="view-info-left">
            <span>{{rowData.viewNum}}人浏览</span>
            <span>{{rowData.favorNum}}人订阅</span>
          </div>
          <!-- <van-button
            size="mini"
            round
            class="favor-btn"
            type="default">
            {{rowData.isFavor ? '已订阅' : '订阅'}}
          </van-button> -->
        </div>
      </div>
    </div>
    <div v-if="type === 'detail'" class="intro">
      {{rowData.intro}}
    </div>
  </div>
</template>
<script>
import { getDateDiff } from '../utils/lib';
export default {
  props: {
    rowData: {
      type: Object,
      default: () => {} 
    },
    type: {
      type: String,
      default: 'detail'
    }
  },
  data() {
    return {
      getDateDiff,
    }
  },
  methods: {
    goDetail() {
      if (this.type === 'detail') return;
      this.$router.push({ name: 'columnDetail', params: { id: this.rowData.id } })
    },
  }
}
</script>
<style lang="less" scoped>
.column-card {
  background: #fff;
  padding: 10px;
  border-radius: 4px;
  text-align: left;
  margin: 10px 12px 10px 12px;
}
.column-top {
  display: flex;
}
.column-logo {
  width: 112px;
  height: 70px;
  border: 1px solid #f0f0f2;
}
.column-info-warp {
  flex: 1;
  overflow: hidden;
  margin-left: 12px;
}
.sd_column_card_name_tag {
  display: inline-block;
  flex-shrink: 0;
  margin-right: 4px;
  padding: 2px 4px;
  font-weight: normal;
  font-size: 12px;
  line-height: 1;
  border-style: solid;
  border-width: 1px;
  border-radius: 2px;
  &[inOrOut='1'] {
    color: #9acd32;
    border-color: #9acd32;
  }
  &[inOrOut='0'] {
    color: #f6af58;
    border-color: #f6af58;
  }
}
.title-warp {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.column-title {
  margin-left: 4px;
  font-size: 16px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.favor-btn {
  padding: 0 8px;
  height: 20px;
  border-radius: 12px;
  flex-shrink: 0;
}
.info {
  font-size: 13px;
  margin-bottom: 2px;
  color: #a5a3a3;
  & > span {
    margin-right: 12px;
  }
}
.view-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #bbb;
  &-left {
    & > span {
      margin-right: 12px;
    }
  }
}
.intro {
  margin-top: 10px;
  color: #666;

}
</style>